import Vue from 'vue';

Vue.component('switch-button-component', {
    props: {
        isSwitchButtonVisible: {
            type: Boolean,
            default: false,
        },

        requestIndex: {
            type: Number,
        },

        labelClassMethod: {
            type: Function,
        },

        privateUrl: {
            type: String,
            default: '',
        },

        businessUrl: {
            type: String,
            default: '',
        },
    },

    methods: {
        handlePrivateLabelClass(requestType) {
            EventBus.$emit('request-type-changed', requestType);
            return requestType === 'private'
                ? 'new-form__label-switch--selected'
                : '';
        },

        handleBusinessLabelClass(requestType) {
            EventBus.$emit('request-type-changed', requestType);
            return requestType === 'business'
                ? 'new-form__label-switch--selected'
                : '';
        },

        handleLabelKeydown(event, index) {
            // Handle keyboard interaction for radio inputs
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();

                // Update the request index and type
                this.$parent.requestIndex = index;
                this.$parent.requestType = index === 0 ? 'private' : 'business';

                // Emit event for external listeners
                EventBus.$emit(
                    'request-type-changed',
                    this.$parent.requestType,
                );

                // The radio input will be automatically checked by the v-model
                // But we also trigger change event for any listeners
                event.target.dispatchEvent(
                    new Event('change', { bubbles: true }),
                );
            }

            // Handle arrow key navigation between radio inputs (WCAG 2.2 AA compliance)
            else if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
                event.preventDefault();
                const newIndex = event.key === 'ArrowLeft' ? 0 : 1;

                // Update the selection
                this.$parent.requestIndex = newIndex;
                this.$parent.requestType =
                    newIndex === 0 ? 'private' : 'business';

                // Emit event for external listeners
                EventBus.$emit(
                    'request-type-changed',
                    this.$parent.requestType,
                );

                // Focus the corresponding radio input
                const targetRadioId =
                    newIndex === 0
                        ? 'request-type-private'
                        : 'request-type-business';

                // Wait for Vue to update the DOM with new tabindex values
                this.$nextTick(() => {
                    const targetRadio = document.getElementById(targetRadioId);
                    if (targetRadio) {
                        targetRadio.focus();
                        // The radio input will be automatically checked by the v-model
                        // But we trigger change event for consistency
                        targetRadio.dispatchEvent(
                            new Event('change', { bubbles: true }),
                        );
                    }
                });
            }
        },
    },
});
